import React from 'react';
import '../css/Floater.css';


function Floater() {
  return (
     <div className="floater">
      <div className="floater-item">
        <a href="mailto:info@peregrinee.com" className="floater-link">
          📧 info@peregrinee.com
        </a>
      </div>
      {/* <div className="floater-item">
        <a href="https://wa.me/9875645936?text=Hi!%20Can%20we%20schedule%20a%20meeting?" target="_blank" rel="noopener noreferrer" className="floater-link">
          📞 +91 98756 45936
        </a>
      </div> */}
    </div>
  );
}

export default Floater;
